import React from 'react'
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { containerVariants, itemVariants } from "../../variants/variants";

const Section1 = () => {
  const { t } = useTranslation();

  return (
    <motion.div 
      initial="hidden"
      whileInView="visible"
      exit="exit"
      variants={containerVariants} className="my-14  ">
      <motion.h1 variants={itemVariants} className=" text-65  text-customBlack mb-5 ">
        {t("socialResponsibility.committee.title")}
      </motion.h1>

      <motion.p variants={itemVariants} className="text-20 font-medium text-customGray5 mb-14 md:w-[80%]">
        {t("socialResponsibility.committee.text")}
      </motion.p>

    </motion.div>
  )
}

export default Section1
